import { DslDefinition, RuntimeModel } from '@kunlun/dependencies';

/**
 * 将对象或数组转为graphql参数格式字符串
 * @param obj 源对象
 * @param enumPropNameList 枚举类型属性名数组，会将枚举类型值的双引号去除
 * @param rModel 根据传入模型自动解析可能的枚举值字段，此时enumPropNameList将用于手动补充枚举值
 */
export function stringifyToGraphql(
  obj: any,
  enumPropNameList: string[] = [],
  rModel?: RuntimeModel,
  parseArrayEnum = false
) {
  let nameList = enumPropNameList;
  if (rModel) {
    nameList = [...nameList, ...Array.from(parseEnumPropNameFromModel(rModel))];
  }
  let json = JSON.stringify(obj);
  // 去除枚举属性值的引号
  if (nameList.length > 0) {
    const reg = new RegExp(`"(${nameList.join('|')})":"(.*?)"`, 'g');
    json = json.replace(reg, '"$1":$2');
  }

  if (parseArrayEnum) {
    const regArray = new RegExp(`"(${['tradeOrderOptions'].join('|')})":\\s*\\[(.*?)\\]`, 'g');
    json = json.replace(regArray, (match, p1, p2) => {
      const items = p2.replace(/"([^"\\\\]*)"/g, '$1');
      return `"${p1}":[${items}]`;
    });
  }

  // 去除所有属性名的引号
  const reg2 = new RegExp(`((?!\\\\).)"([^,]*?)((?!\\\\).)":`, 'g');

  return json.replace(reg2, '$1$2$3:');
}

// fixme #号可能在实际内容内
export function graphqlQueryFormatter(query: string) {
  return query
    .replace(/ #[^"]*?(?=\n|$)/gm, '')
    .replace(/[\r\n\t]/gm, ' ')
    .replace(/\s+/gm, ' ');
}

export function parseEnumPropNameFromModel(rModel: RuntimeModel) {
  const modelFields = rModel.modelFields;
  const result = new Set<string>();

  const widgets: DslDefinition[] = [];
  modelFields.forEach((field) => {
    if (field.ttype === 'ENUM') {
      result.add(field.name);
    }
    if (field.template?.widgets?.length) {
      widgets.push(...field.template?.widgets);
    }
  });

  while (widgets.length > 0) {
    const widget = widgets.shift();

    if (!widget) {
      continue;
    }
    if (widget.ttype === 'ENUM' && widget.name) {
      result.add(widget.name);
    }
    if (widget.widgets?.length) {
      widgets.push(...widget.widgets);
    }
    if (widget.options?.length) {
      widget.options.forEach((option) => {
        if (option.widgets?.length) {
          widgets.push(...option.widgets);
        }
      });
    }
  }

  return result;
}
